import { render, staticRenderFns } from "./ModalDashboard.vue?vue&type=template&id=0df4ba05&scoped=true"
import script from "./ModalDashboard.vue?vue&type=script&lang=js"
export * from "./ModalDashboard.vue?vue&type=script&lang=js"
import style0 from "./ModalDashboard.vue?vue&type=style&index=0&id=0df4ba05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df4ba05",
  null
  
)

export default component.exports